import styled from 'styled-components';
import { toRem } from '@marriott/mi-ui-library';

export const StyledAdditionalInfo = styled.div`
  .title {
    padding-bottom: ${toRem(40)};
  }
`;
